import { render, staticRenderFns } from "./mypjxq.vue?vue&type=template&id=aa6889e0&scoped=true&"
import script from "./mypjxq.vue?vue&type=script&lang=js&"
export * from "./mypjxq.vue?vue&type=script&lang=js&"
import style0 from "./mypjxq.vue?vue&type=style&index=0&id=aa6889e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6889e0",
  null
  
)

export default component.exports